/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module for Support components.
 * @preferred
 * @module SupportModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClrIconModule } from '@clr/angular';
import { SharedModule } from 'ng/shared/shared.module';
import { AviCardModule } from 'nsx-alb-ui-components';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { CoreModule } from '../core/core.module';

import {
    asyncFactoryProvider,
} from './ajs-upgraded-providers';

const techSupportProviders = [
    asyncFactoryProvider,
];

/**
 * @description Angular Module for Support components.
 * @author: Shahab Hashmi, Chetana Padmane
 */
@NgModule({
    declarations: [],
    imports: [
        AviCardModule,
        AviFormsModule,
        SharedModule,
        BrowserAnimationsModule,
        ClrIconModule,
        CommonModule,
        DataGridModule,
        CoreModule,
    ],
    exports: [],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA,
    ],
    providers: [...techSupportProviders],
})
export class SupportModule {}
